export { default as v1 } from './v1.js';
export { default as v3 } from './v3.js';
export { default as v4 } from './v4.js';
export { default as v5 } from './v5.js';


//////////////////
// WEBPACK FOOTER
// ./~/uuid/dist/esm-browser/index.js
// module id = 1529
// module chunks = 1